import css from "styled-jsx/css";
import config from "lib/config";

const spriteCertification = `${config.CDN_PREFIX}/static/assets/images/sprite-certification.png`;
const certifications = `${config.CDN_PREFIX}/static/assets/images/home/certifications.png`;
const c2exIcon = `${config.CDN_PREFIX}/static/assets/images/home/C2EX.svg`;
const cretsIcon = `${config.CDN_PREFIX}/static/assets/images/home/crets.svg`;
const hfr = `${config.CDN_PREFIX}/static/assets/images/home/HFR.svg`;

export default css`
  @import "src/static/styles/variables";
  @import "src/static/styles/mixins/mixins";

  .desigations_certifications-icons ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    list-style-type: none;
  }
  .popover-hover {
    position: relative;
  }
  .popover-hover i {
    background-image: url(${spriteCertification});
    background-size: 174px 174px;
  }
  [class*="icon-certification-"] {
    background-repeat: no-repeat;
    border-radius: 50%;
    display: inline-block;
    float: left;
    height: 30px;
    width: 30px;
    margin: 0 4px 4px;
  }

  .icon-certification-abr {
    background-position: 0 0;
  }
  .icon-certification-ahwd {
    background-position: -72px 0;
  }
  .icon-certification-alc {
    background-position: -108px 0;
  }
  .icon-certification-ccim {
    background-position: -144px 0;
  }
  .icon-certification-cips {
    background-position: 0 -36px;
  }
  .icon-certification-cpm {
    background-position: -36px -36px;
  }
  .icon-certification-crb {
    background-position: -72px -36px;
  }
  .icon-certification-cre {
    background-position: -108px -36px;
  }
  .icon-certification-crs {
    background-position: -144px -36px;
  }
  .icon-certification-epro {
    background-position: 0 -72px;
  }
  .icon-certification-gaa {
    background-position: -36px -72px;
  }
  .icon-certification-grn {
    background-position: -72px -72px;
  }
  .icon-certification-gri {
    background-position: -108px -72px;
  }
  .icon-certification-pmn {
    background-position: -144px -72px;
  }
  .icon-certification-psa {
    background-position: -72px -108px;
  }
  .icon-certification-raa {
    background-position: -36px -108px;
  }
  .icon-certification-rene {
    background-position: 0 -108px;
  }
  .icon-certification-rsps {
    background-position: -108px -108px;
  }
  .icon-certification-sfr {
    background-position: -144px -108px;
  }
  .icon-certification-sior {
    background-position: 0 -144px;
  }
  .icon-certification-sres {
    background-position: -36px -144px;
  }
  .icon-certification-srs {
    background-position: -72px -144px;
  }
  .icon-certification-mrp {
    background-position: -108px -144px;
  }
  .icon-certification-bpor {
    background-position: -144px -144px;
  }
  .icon-certification-crets {
    background-image: url(${cretsIcon}) !important;
    background-size: contain !important;
  }
  .icon-certification-c2ex {
    background-image: url(${c2exIcon}) !important;
    background-size: contain !important;
  }
  .icon-certification-hfr {
    background-image: url(${hfr}) !important;
    background-size: contain !important;
  }
  .logo-abr {
    background-position: -16px -10px;
  }
  .logo-ahwd {
    background-position: -16px -150px;
  }
  .logo-alc {
    background-position: -16px -1760px;
  }
  .logo-bpor {
    background-position: -16px -290px;
  }
  .logo-ccim {
    background-position: -16px -360px;
  }
  .logo-cips {
    background-position: -16px -430px;
  }
  .logo-cpm {
    background-position: -16px -1830px;
  }
  .logo-crb {
    background-position: -16px -1900px;
  }
  .logo-cre {
    background-position: -16px -640px;
  }
  .logo-crs {
    background-position: -16px -2040px;
  }
  .logo-epro {
    background-position: -12px -2110px;
  }
  .logo-hfr {
    background-position: -16px -2240px;
  }
  .logo-gaa {
    background-position: -16px -850px;
  }
  .logo-grn {
    background-position: -16px -920px;
  }
  .logo-gri {
    background-position: -16px -990px;
  }
  .logo-mrp {
    background-position: -16px -1060px;
  }
  .logo-pmn {
    background-position: -16px -1130px;
  }
  .logo-psa {
    background-position: -16px -1200px;
  }
  .logo-raa {
    background-position: -16px -1270px;
  }
  .logo-rene {
    background-position: -16px -1340px;
  }
  .logo-rsps {
    background-position: -16px -1407px;
  }
  .logo-sfr {
    background-position: -16px -1480px;
  }
  .logo-sior {
    background-position: -16px -1550px;
  }
  .logo-sres {
    background-position: -16px -1620px;
  }
  .logo-srs {
    background-position: -16px -1690px;
  }
  .logo-crets {
    background-position: -16px -1970px;
  }
  .logo-pnm {
    background-position: -16px -1130px;
  }
  .logo-c2ex {
    background-position: -16px -2180px;
  }
  .select-logo {
    background-color: $body-bg;
    background-image: url(${certifications});
    background-repeat: no-repeat;
    position: static;
    vertical-align: text-top;
    height: 60px;
    width: 120px;
    @include grid(false);
    margin-left: 10px;
  }
  .inline-text-certification {
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
  .certDetailWrapper {
    display: flex;
    margin-top: 9px;
    width: 100%;
  }
  .summaryBlock {
    width: 65%;
  }
  .icon-certification-extra {
    background-color: #999;
    background-image: none;
    color: white;
    line-height: 30px;
    text-align: center;
    text-decoration: none;
  }
  .icon-certification-extra:hover {
    color: #d92228;
  }
  @include mobile {
    .desigations_certifications-icons {
      width: 100%;
    }
  }
`;
